import { render, staticRenderFns } from "./WizardFour.vue?vue&type=template&id=4c85fe9e"
import script from "./WizardFour.vue?vue&type=script&lang=ts"
export * from "./WizardFour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports